import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setOnline,
  setOffline,
} from "../features/networkStatus/networkStatusSlice";

const useNetworkStatus = () => {
  const dispatch = useDispatch();
  const isOnline = useSelector((state) => state.networkStatus.isOnline);
  const isApiReachable = useSelector(
    (state) => state.networkStatus.isApiReachable
  );

  useEffect(() => {
    // ensure the initial state is correct when the component mounts
    if (typeof window !== "undefined" && window.navigator) {
      window.navigator.onLine ? dispatch(setOnline()) : dispatch(setOffline());
    }

    const handleOnline = () => dispatch(setOnline());
    const handleOffline = () => dispatch(setOffline());

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [dispatch]);

  return { isOnline: isOnline && isApiReachable };
};

export default useNetworkStatus;
